const account_center = {
    not_enabled: 'アカウントセンターが有効になっていません。',
    field_not_editable: 'フィールドは編集できません。',
    field_not_enabled: 'フィールドが有効になっていません。',
};
export default Object.freeze(account_center);
